import axios from 'axios';
import Promise from 'promise';
// import store from './../store'
import {
  Message
} from 'element-ui';
// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (window.sessionStorage.token) {
      config.headers.Authorization = window.sessionStorage.token;
    }
    config.headers['Cache-Control'] = 'no-cache';
    return config;
  },
  (err) => {
    Message({
      showClose: true,
      message: err,
      type: 'error'
    });
    return Promise.reject(err);
  }
);
// http response 拦截器 返回状态判断
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.code === 0) {
      return response;
    }
    if (!window.sessionStorage.mainId) {
      localStorage.clear();
      sessionStorage.clear();
      axios.post('/erp/login/backend_get_auth_link', {
        reUrl: `${window.location.href.split('#')[0]}#/stage/index`
      }).then((res) => {
        if (res.data.code == 0) {
          window.location.href = res.data.data;
        } else {
          Message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
      });
      return;
    }
    if (response.data && response.data.code === 502) {
      if (window.sessionStorage.setUrlStatus == 2) {
        Message({
          showClose: true,
          message: response.data.msg,
          type: 'error'
        });
      }
      return response;
    }
    if (response.data.code === 888) {
      if (this.$isDesktop() === true) {
        // register()
      } else {
        localStorage.clear();
        sessionStorage.clear();
        axios.post('/erp/login/backend_get_auth_link', {
          reUrl: `${window.location.href.split('#')[0]}#/stage/index`
        }).then((res) => {
          if (res.data.code == 0) {
            window.location.href = res.data.data;
          } else {
            Message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            });
          }
        });
      }
    }
    if (response.data.code != 0 && response.data.msg && response.data.msg != '错误') {
      Message({
        showClose: true,
        message: response.data.msg,
        type: 'error'
      });
      return response;
    }
    return {
      code: 400
    };
  },
  (error) => {
    const url = `${error}`;
    if ((url.indexOf('10000ms') > -1) && (window.sessionStorage.stopTime * 1 > 10000)) {
      $('#poorNetworkR').css('display', 'block');
      $('#poorNetworkD').css('display', 'none');
    }
    Message({
      showClose: true,
      message: error.response.status,
      type: 'error'
    });
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);
// 在实例已创建后修改默认值
if (window.location.href.indexOf('gg.deeptel.com.cn') > 0) {
  // axios.defaults.baseURL = 'http://192.168.11.221:8080';
  // axios.defaults.baseURL = 'http://192.168.9.65:8080';
  // axios.defaults.baseURL = 'https://nbyangzi.deeptel.com.cn';
  axios.defaults.baseURL = 'https://yangzi.deeptel.com.cn';
  // axios.defaults.baseURL = 'https://beauty.duofriend.com';
}

// 响应时间
axios.defaults.timeout = 20000;
// `withCredentails`选项表明了是否是跨域请求
axios.defaults.withCredentials = true;
// 设置默认请求头
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Content-Type': 'application/json; charset=UTF-8',
};
const Axios = axios.create({

});
Axios.get = (url, params) => axios.get(url, {
  params,
}).then((res) => res);
Axios.post = (url, params) => axios.post(url, params).then((res) => res);
export default Axios;
